import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { PolicyDocumentTaskApiModel, AssignPolicyDocumentTaskApiModel } from '@app/api/api-models/program/PolicyDocumentTaskApiModel';
import { BulkAssignPolicyDocumentTaskApiModel } from '@app/api/api-models/program/BulkAssignPolicyDocumentTaskApiModel';

@Injectable()
export class PolicyDocumentTasksService {
  public apiUrl = 'policy-document-tasks';

  constructor(private readonly http: HttpClientService) {}

  public getList(programRoleId: string, status = 'incomplete', phaseId?: number): Observable<PolicyDocumentTaskApiModel[]> {
    let params: any = {
      programRoleId: programRoleId,
      status: status
    };

    if (phaseId != null) {
      params.phaseId = phaseId.toString();
    }

    return this.http.get<PolicyDocumentTaskApiModel[]>(this.apiUrl, { params });
  }

  public getIncompleteCount(programRoleId: string): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/incomplete-count`, {
      params: { programRoleId: programRoleId }
    });
  }

  public assign(model: AssignPolicyDocumentTaskApiModel): Observable<PolicyDocumentTaskApiModel> {
    return this.http.post<PolicyDocumentTaskApiModel>(`${this.apiUrl}/assign`, model);
  }

  public assignBulk(model: BulkAssignPolicyDocumentTaskApiModel): Observable<PolicyDocumentTaskApiModel[]> {
    return this.http.post<PolicyDocumentTaskApiModel[]>(`${this.apiUrl}/assign-bulk`, model);
  }
}
